module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-2-1.43588e2d.png";